import { Flex, Spin, Typography } from 'antd'

export function LoadingScreen({ text }: { text: string }) {
  return (
    <Flex vertical align="center" gap={12} style={{ padding: '40px 0' }}>
      <Spin size="large" />
      <Typography.Text type="secondary">{text}</Typography.Text>
    </Flex>
  )
}
